import React, { useRef, useEffect } from 'react';
import { Application } from '@splinetool/runtime';
import styles from './ProbeResultsModal.module.scss';

function ProbeResultsModal({ open, onClose, probeData }) {
  const canvasRef = useRef(null);
  const splineAppRef = useRef(null);

  // Resize Spline canvas to fit container
  const resizeSplineCanvas = React.useCallback(() => {
    if (canvasRef.current && splineAppRef.current) {
      const container = canvasRef.current.parentElement;
      const width = container.clientWidth;
      const height = container.clientHeight;
      
      // Set canvas size to match container
      canvasRef.current.width = width;
      canvasRef.current.height = height;
      
      // Update Spline app size if it has a setSize method
      if (splineAppRef.current.setSize) {
        splineAppRef.current.setSize(width, height);
      }
      
      console.log(`🔄 Resized Spline canvas to ${width}x${height}`);
    }
  }, []);

  useEffect(() => {
    if (open && canvasRef.current && !splineAppRef.current) {
      // Initialize Spline application for the probe results scene
      const app = new Application(canvasRef.current);
      splineAppRef.current = app;
      
      // Load the probe results Spline scene
      app.load('https://prod.spline.design/L51IywDSlolVBOkS/scene.splinecode')
        .then(() => {
          console.log('Probe results scene loaded successfully');
          // Initial resize to fit container
          resizeSplineCanvas();
        })
        .catch((error) => {
          console.error('Error loading probe results scene:', error);
        });
    }

    // Cleanup when modal closes
    return () => {
      if (!open && splineAppRef.current) {
        splineAppRef.current.dispose();
        splineAppRef.current = null;
      }
    };
  }, [open, resizeSplineCanvas]);

  // Handle window resize
  useEffect(() => {
    if (!open) return;

    const handleResize = () => {
      resizeSplineCanvas();
    };

    // Resize on window resize
    window.addEventListener('resize', handleResize);
    
    // Also resize when modal opens (after a brief delay to ensure layout is ready)
    const timeoutId = setTimeout(resizeSplineCanvas, 100);

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, [open, resizeSplineCanvas]);

  // Handle modal close
  const handleClose = () => {
    if (splineAppRef.current) {
      splineAppRef.current.dispose();
      splineAppRef.current = null;
    }
    onClose();
  };

  return (
    <div className={`${styles.probeResultsModal} ${open ? styles.open : ''}`}>
      {/* Modal Header */}
      <div className={styles.header}>
        <h2>Probe Analysis Results</h2>
        <button className={styles.closeButton} onClick={handleClose}>×</button>
      </div>
      
      {/* Spline Scene Container */}
      <div className={styles.sceneContainer}>
        <canvas 
          ref={canvasRef}
          className={styles.splineCanvas}
        />
      </div>
      
      {/* Probe Data Display */}
      {probeData && (
        <div className={styles.dataPanel}>
          <h3>Telemetry Data</h3>
          <ul>
            <li>Target: {probeData.target}</li>
            <li>Status: {probeData.status}</li>
            <li>Distance: {probeData.distance}</li>
            <li>Signal: {probeData.signal}</li>
            <li>Analysis: {probeData.analysis}</li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default ProbeResultsModal;

